import { api } from '@/lib/api';

export interface ProfileData {
  userId: number;
  email: string;
  name: string;
  subscription?: {
    plan: string;
    videosUsed: number;
    videosLimit: number;
    quality: string;
  };
}

export const profileService = {
  async getProfile(): Promise<ProfileData> {
    const response = await api.get('/profile/me');
    return response.data;
  },

  async updateProfile(name: string): Promise<void> {
    await api.patch('/profile/update', { name });
  },

  async changePassword(currentPassword: string, newPassword: string): Promise<void> {
    await api.post('/profile/change-password', {
      current_password: currentPassword,
      new_password: newPassword
    });
  },

  async deleteAccount(): Promise<void> {
    await api.delete('/profile/delete-account');
  }
}; 